import React, { useState } from 'react';
import imgLogo from '../assets/icons/svg/bpims.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-32 flex items-center justify-between h-16">
        <div className="flex items-center">
          <img
            src={imgLogo}
            alt="BPI MS Insurance Logo"
            className="h-10 w-auto"
          />
        </div>

        <nav className="hidden md:flex items-center space-x-6">
          <a
            href="https://bpims.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-800 font-bold hover:text-[#B01116] transition"
          >
            ABOUT BPI MS
          </a>
          <a
            href="#contact-us"
            className="text-[#B01116] font-bold hover:text-gray-800 transition"
          >
            CONTACT US
          </a>
        </nav>

        <button
          className="md:hidden flex items-center text-gray-800 focus:outline-none"
          onClick={toggleMenu} 
          aria-label="Toggle menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>

      {isMenuOpen && (
        <nav className="md:hidden bg-white shadow-lg">
          <ul className="flex flex-col items-center py-4 space-y-4">
            <li>
              <a
                href="https://bpims.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-800 font-bold hover:text-[#B01116] transition"
              >
                ABOUT BPI MS
              </a>
            </li>
            <li>
              <a
                href="#contact-us"
                className="text-[#B01116] font-bold hover:text-gray-800 transition"
              >
                CONTACT US
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Header;
